import { render, staticRenderFns } from "./ActivateCustomer.vue?vue&type=template&id=402bd64c"
import script from "./ActivateCustomer.vue?vue&type=script&lang=js"
export * from "./ActivateCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports